<template>
	<div class="prouduct-detail">
		<span class="lt title-text">{{theEndWord[0]}}</span>
		<div class="product-link">
			<div @click="jumprouter(item)" class="mix-content" v-for="(item, index) in prouductDetail">
				<img :class="'a' + item" :src="'static/image/prouduct-img/' + item + '.jpg'"/>
				<span>{{index}}</span>
			</div>
		</div>
		<span class="lt title-text">{{theEndWord[2]}}</span>
		<div class="friend-link">
			<div class="friend-link-wrapper">
				<a class="friend-logo" v-for="(item, index) in logoLink" :href="item[2]">
					<img :src="'static/image/bright-img/friend-logo/' + item[1] + '.jpg'"/>
					<span class="explain-word">{{item[0]}}</span>
				</a>
			</div>
		</div>
	</div>
</template>

<script type="text/ecmascript-6">
export default {
	data() {
		return {
			logoLink: [
				['',1,'https://www.budenheim.com/en/'],
				['',2,'http://www.struktol.com/'],
				['',3,'https://www.byk.com/cn'],
				['',4,'http://www.tolsa.com/'],
				['',5,'http://www.lucobit-china.com/'],
				['',6,'https://www.frxpolymers.com/'],
				['',7,'https://www.oka-tec.com/'],
				['',8,'http://www.bfchemicals.com'],
				['',9,'http://www.Hycat.com'],
				['',10,'http://www.bostik.com.cn/cn/china/'],
				['',11,'http://www.polyram-group.com'],
				['',12,'https://www.roquette.com/'],
				['',13,'https://www.velox.com/home/'],
				['',14,'http://www.apvcoatings.com/'],
				['',15,'https://www.reagens-group.com/']
			]
		}
	},
	methods: {
		jumprouter(index) {
			let num = 'prouductCenter/page' + index
			let routid = 'arch' + index
			console.log(this.$route)
			this.$router.push({path: num})
			localStorage.setItem('id', routid)
		}
	},
	computed: {
		prouductDetail() {
			return this.$t('prouductDetail')
		},
		theEndWord() {
			return this.$t('theEndWord')
		}
	}
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import "~common/stylus/variable"

	.product-link
		width: 100%
		max-width: 1200px
		margin: 20px auto 0
		display: flex
		flex-wrap: wrap
		justify-content: center
		@media screen and (max-width:550px)
			width: 75%
			justify-content: space-between
		.mix-content
			display: flex
			flex-direction: column
			// align-items: center
			margin: 30px
			@media screen and (max-width:550px)
				margin: 5px
			img
				display: block
				@media screen and (max-width:550px)
					width: 120px
			span
				font-size: $font-web-small
	.lt
		display: block
		text-align: center
	.title-text
		width: 150px
		display: block
		margin: 0 auto
		text-align: center
		line-height: 30px
		height: 30px
		font-size: $font-size-medium
		background: $color-theme
		color: $color-text
		cursor: pointer
		&:hover
			background: $color-text
			color: $color-theme
			border: 1px solid $color-theme
	.entitle
		font-size: $font-web-small-l
	.friend-link
		position: relative
		margin: 30px 0 
		@media screen and (max-width:550px)
			margin-bottom: 0
		.all-product
			width: 150px
			display: block
			margin: 0 auto
			text-align: center
			line-height: 30px
			height: 30px
			font-size: $font-web-small
			background: $color-theme
			color: $color-text
			cursor: pointer
		.friend-link-wrapper
			width: 80%
			margin: 30px auto 50px
			display: flex
			flex-wrap: wrap
			justify-content: space-between
			.friend-logo
				width: 20%
				padding: 20px
				cursor: pointer
				@media screen and (max-width:850px)
					width: 30%
				img
					width: 75%
					padding-left: 25%
					@media screen and (max-width:550px)
						width: 100%
						padding: 0
				.explain-word
					display: block
					text-align: center
</style>



// WEBPACK FOOTER //
// src/components/prouduct-detail/prouduct-detail.vue